<script lang="ts" setup>
import { onMounted } from 'vue'
import { hubspotModalInstanceId } from '@/stores'

onMounted(() => {
  for (const el of document.getElementsByClassName('markdown')) {
    for (const a of el.getElementsByTagName('a')) {
      if (a.innerHTML.includes('use the form located here')) {
        a.addEventListener('click', (e) => {
          e.preventDefault()
          hubspotModalInstanceId.value = 'privacy-request'
        })
      }
    }
  }
})
</script>
<template>
  <div />
</template>
